import React from 'react'

import InstructorCard from '../../components/InstructorCard'
import SectionContent from '../../components/SectionContent'
import SectionHeader from '../../components/SectionHeader'
import SectionLayout from '../../components/SectionLayout'
import { instructorsDetails } from '../../data/instructors'

const InstructorSection = () => {
  return (
    <SectionLayout>
      <SectionHeader>
        <span className="text-primary">Meet</span> Our Instructor
      </SectionHeader>
      <SectionContent>
        {instructorsDetails.map(({ id, ...rest }) => (
          <InstructorCard key={id} {...rest} />
        ))}
      </SectionContent>
    </SectionLayout>
  )
}

export default InstructorSection
